import { useCallback, useState } from 'react'
import { ButtonPrimary } from '../../../../../baseComponents/Button'
import { OrderData } from '../../../../inputTableLayouts/order/OrderLayout/types'
import { ModalOpenedTy } from '../../../../../baseComponents/Modal/types'
import ModalOrderRefundProcess from './ModalOrderRefundProcess'
import PermissionChecker from '../../../../../baseComponents/PermissionChecker'
import { parseRefundConflicts } from '../../../../inputTableLayouts/order/OrderLayout/useMultiOrderRefundLogic/functions'
import { TwinDictionary } from '../../../../../utils/globals/dictionary'
import TwinTrans from '../../../../../baseComponents/TwinTrans'
import { UserPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import { InputTableLayoutData } from '../../../../../baseComponents/TwinTable/InputTableLayout/types'
import ModalOrderRefundConflictsUniqueNumbers from './ModalOrderRefundConflictsUniqueNumbers'
import ModalOrderRefundConflictsWarehouses from './ModalOrderRefundConflictsWarehouses'

interface MultiOrderRefundButtonProps {
    data: OrderData
    urlProcess: string
    setCompleteData: React.Dispatch<React.SetStateAction<InputTableLayoutData | null >>
    translationsModal: {
        title: string
        subtitle: string
    },
    userPermission: UserPermissions | false
    urlNavigate: string
}

const MultiOrderRefundButton: React.FC<MultiOrderRefundButtonProps> = ({ data, urlProcess, translationsModal, ...logic}) => {
    return (
        <div className='flex justify-start flex-wrap ml-auto items-center gap-15'>
            <CreateOrderRefundButton data={data} translationsModal={translationsModal} urlProcess={urlProcess} {...logic} />
        </div>
    )
}

interface MultiSellButtonProps extends MultiOrderRefundButtonProps {
    children?: React.ReactNode
}

const CreateOrderRefundButton: React.FC<MultiSellButtonProps> = ({ data, translationsModal, setCompleteData, ...rest }) => {
    const { opened, setOpened, conflicts, handleOrderRefundProcess, setConflicts } = useCreateOrderRefundButtonLogic({ data })
    return (
        <PermissionChecker permission='create' userPermissions={rest.userPermission}>
            <div className='items-center flex ml-auto'>
                <ButtonPrimary id={'orderRefund' + data?.header?.id} onClick={handleOrderRefundProcess} disabled={data?.selectedTableData?.length ? false : true}><TwinTrans transKey='generateRefund'>Generar devolución</TwinTrans></ButtonPrimary>
                {opened && conflicts?.['unique_numbers'] ? <ModalOrderRefundConflictsUniqueNumbers {...{ setConflicts, conflicts, setCompleteData, setOpened}} /> : null}
                {opened && !conflicts?.['unique_numbers'] && conflicts?.['warehouses'] ? <ModalOrderRefundConflictsWarehouses {...{ setConflicts, conflicts, setCompleteData, setOpened, data}} /> : null}
                {opened && !conflicts ? <ModalOrderRefundProcess {...{ setOpened, data, translations: translationsModal, ...rest }} /> : null}
            </div>
        </PermissionChecker>
    )
}

interface CreateOrderRefundButtonLogicProps {
    data: OrderData
}

const useCreateOrderRefundButtonLogic = ({ data }: CreateOrderRefundButtonLogicProps) => {
    const [opened, setOpened] = useState<ModalOpenedTy>(null)
    const [conflicts, setConflicts] = useState<TwinDictionary | null>(null)
    
    const handleOrderRefundProcess = useCallback(async () => {
        const myConflicts = parseRefundConflicts(data)
        if (myConflicts && Object.keys(myConflicts)?.length) {
            setConflicts(myConflicts)
        }
        setOpened(true)
    }, [setOpened, data])
    return { opened, setOpened, handleOrderRefundProcess, setConflicts, conflicts }
}


export default MultiOrderRefundButton